import { render } from "./AdminBoxSetStage.vue?vue&type=template&id=70b5fd4e&scoped=true"
import script from "./AdminBoxSetStage.vue?vue&type=script&lang=js"
export * from "./AdminBoxSetStage.vue?vue&type=script&lang=js"

import "./AdminBoxSetStage.vue?vue&type=style&index=0&id=70b5fd4e&scoped=true&lang=sass"

import exportComponent from "/home/ploi/orthomatrix.orthosol.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70b5fd4e"]])

export default __exports__